import * as mutationTypes from '@/store/mutation-types'
import {State} from "@/interfaces/stateInterface";

import {set} from "lodash";

export default {
    // update is authenticated user
    [mutationTypes.UPDATE_IS_AUTHENTICATED_USER] (state: State, isAuthenticated: boolean) {
        state.isAuthenticated = isAuthenticated;
    },
    // Update global tab index
    [mutationTypes.UPDATE_GLOBAL_TAB_INDEX] (state: State, globalTabIndex: number) {
        state.globalTabIndex = globalTabIndex
    },
    // Update show global loader
    [mutationTypes.UPDATE_SHOW_GLOBAL_LOADER] (state: State, showGlobalLoader: boolean) {
        state.showGlobalLoader = showGlobalLoader
    },
    // Update show global loader
    [mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER] (state: State, showTransparentGlobalLoader: boolean) {
        state.showTransparentGlobalLoader = showTransparentGlobalLoader
    },
    // Update connected user
    [mutationTypes.UPDATE_CONNECTED_USER] (state: State, connectedUser: any) {
        state.user = connectedUser
    },
    [mutationTypes.UPDATE_PROFILE] (state: State, {key, value}: any) {
        set(state.profile, key, value);
    }
}
